import { Button } from 'components/atoms';
import WarningPopup, {
  IWarningPopupProps,
} from 'components/molecules/popup/warning-popup/WarningPopup';
import { IButtonProps } from 'types/components/button/button.interface';

interface IConditionalWarningPopupButtonProps
  extends Omit<IButtonProps, 'title'>, IWarningPopupProps {
  showWarning?: boolean;
}

const ConditionalWarningPopupButton = ({
  onConfirm,
  title,
  message,
  confirmButtonVariant,
  showWarning,
  ...buttonProps
}: IConditionalWarningPopupButtonProps) => {
  return (
    <>
      {showWarning ? (
        <WarningPopup
          onConfirm={onConfirm}
          title={title}
          message={message}
          confirmButtonVariant={confirmButtonVariant}
          trigger={<Button {...buttonProps} onClick={undefined} />}
        />
      ) : (
        <Button
          {...buttonProps}
          onClick={() =>
            onConfirm &&
            onConfirm({
              open: () => {},
              close: () => {},
              toggle: () => {},
            })
          }
        />
      )}
    </>
  );
};

export default ConditionalWarningPopupButton;
